module.exports = __webpack_public_path__ + "img/overview-active.93d2856a.svg";